/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function SettingsXsmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'SettingsXsmall',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M11 6.625v-1.25l-1.67-.322a3.4 3.4 0 0 0-.306-.74l.954-1.408-.884-.883-1.41.953q-.346-.194-.737-.304L6.625 1h-1.25l-.322 1.67a3.5 3.5 0 0 0-.738.306l-1.41-.954-.883.884.954 1.408q-.195.348-.306.74L1 5.374v1.25l1.67.322q.112.391.307.74L2.022 9.09l.886.885 1.406-.954c.23.13.48.23.74.308l.32 1.67h1.25l.323-1.67q.391-.112.74-.306l1.407.953.884-.884-.954-1.407q.195-.348.306-.738l1.67-.32zM6 7.988a1.987 1.987 0 1 1 0-3.975 1.987 1.987 0 0 1 0 3.975"}))
}
